package dev.mft.website.composable.footer

import androidx.compose.foundation.layout.*
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.platform.UriHandler
import androidx.compose.ui.unit.dp
import androidx.window.core.layout.WindowSizeClass
import androidx.window.core.layout.WindowWidthSizeClass


@Composable
fun Footer(
    modifierMainRow: Modifier,
    uriHandler: UriHandler,
    windowSizeClass: WindowSizeClass
) {
    val config = FooterLayoutConfig.getLayoutConfig(
        windowSizeClass.windowWidthSizeClass,
        windowSizeClass.windowHeightSizeClass
    )

    when (windowSizeClass.windowWidthSizeClass) {
        //smartphone
        WindowWidthSizeClass.COMPACT -> {
            Column(
                modifier = modifierMainRow,
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                val modifierBox: Modifier = Modifier
                    .fillMaxWidth()
                    .weight(1f)

                Skill(
                    modifierBox = modifierBox,
                    fontSize = config.skillFontSize,
                    imageSize = config.skillImageSize,
                    padding = 20.dp
                )

                Contact(
                    modifierBox = modifierBox,
                    uriHandler = uriHandler,
                    fontSize = config.contactFontSize,
                    imageSize = config.contactImageSize
                )
            }
        }
        //tablet
        WindowWidthSizeClass.MEDIUM -> {
            Row(
                modifier = modifierMainRow,
                horizontalArrangement = Arrangement.Center,
                verticalAlignment = Alignment.CenterVertically,
            ) {
                val modifierBox: Modifier = Modifier
                    .fillMaxHeight()
                    .weight(1f)

                //bottom left corner
                Skill(
                    modifierBox = modifierBox,
                    fontSize = config.skillFontSize,
                    imageSize = config.skillImageSize,
                    padding = 40.dp
                )

                //bottom right corner
                Contact(
                    modifierBox = modifierBox,
                    uriHandler = uriHandler,
                    fontSize = config.contactFontSize,
                    imageSize = config.contactImageSize
                )
            }
        }
        //pc
        WindowWidthSizeClass.EXPANDED -> {
            Row(
                modifier = modifierMainRow,
                horizontalArrangement = Arrangement.Center,
                verticalAlignment = Alignment.CenterVertically,
            ) {
                val modifierBox: Modifier = Modifier
                    .fillMaxHeight()
                    .weight(1f)

                //bottom left corner
                Skill(
                    modifierBox = modifierBox,
                    fontSize = config.skillFontSize,
                    imageSize = config.skillImageSize,
                    padding = 50.dp
                )

                //bottom right corner
                Contact(
                    modifierBox = modifierBox,
                    uriHandler = uriHandler,
                    fontSize = config.contactFontSize,
                    imageSize = config.contactImageSize
                )
            }
        }
    }
}